import { apiFetch } from '../../../shared/services/apiClient';
import {
  ClienteDetalle,
  ClienteFiltros,
  CreateClientePayload,
  CreateContactoPayload,
  PaginacionClientes,
  UpdateClientePayload,
  UpdateContactoPayload,
} from '../types';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const clienteService = {
  async listar(filtros: ClienteFiltros = {}): Promise<PaginacionClientes> {
    const params = new URLSearchParams();
    if (filtros.busqueda) params.set('busqueda', filtros.busqueda);
    if (filtros.actividadEconomicaId != null) params.set('actividadEconomicaId', String(filtros.actividadEconomicaId));
    if (filtros.departamentoId != null) params.set('departamentoId', String(filtros.departamentoId));
    if (filtros.granContribuyente != null) params.set('granContribuyente', String(filtros.granContribuyente));
    if (filtros.activo != null) params.set('activo', String(filtros.activo));
    if (filtros.pagina != null) params.set('pagina', String(filtros.pagina));
    if (filtros.limite != null) params.set('limite', String(filtros.limite));
    const res = await apiFetch(`${API_BASE}/clientes?${params}`);
    return handleResponse<PaginacionClientes>(res);
  },

  async obtener(id: string): Promise<ClienteDetalle> {
    const res = await apiFetch(`${API_BASE}/clientes/${id}`);
    return handleResponse<ClienteDetalle>(res);
  },

  async crear(payload: CreateClientePayload): Promise<ClienteDetalle> {
    const res = await apiFetch(`${API_BASE}/clientes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return handleResponse<ClienteDetalle>(res);
  },

  async actualizar(id: string, payload: UpdateClientePayload): Promise<ClienteDetalle> {
    const res = await apiFetch(`${API_BASE}/clientes/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return handleResponse<ClienteDetalle>(res);
  },

  async eliminar(id: string): Promise<void> {
    const res = await apiFetch(`${API_BASE}/clientes/${id}`, { method: 'DELETE' });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || `HTTP ${res.status}`);
    }
  },

  async agregarContacto(clienteId: string, payload: CreateContactoPayload): Promise<void> {
    const res = await apiFetch(`${API_BASE}/clientes/${clienteId}/contactos`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || `HTTP ${res.status}`);
    }
  },

  async actualizarContacto(clienteId: string, contactoId: string, payload: UpdateContactoPayload): Promise<void> {
    const res = await apiFetch(`${API_BASE}/clientes/${clienteId}/contactos/${contactoId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || `HTTP ${res.status}`);
    }
  },

  async eliminarContacto(clienteId: string, contactoId: string): Promise<void> {
    const res = await apiFetch(`${API_BASE}/clientes/${clienteId}/contactos/${contactoId}`, {
      method: 'DELETE',
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || `HTTP ${res.status}`);
    }
  },

  async resumen(): Promise<{ total: number; activos: number; nuevosEsteMes: number }> {
    const res = await apiFetch(`${API_BASE}/clientes/resumen`);
    return handleResponse<{ total: number; activos: number; nuevosEsteMes: number }>(res);
  },
};
